/**
 * Adapter: a feed's provider rows -> ProductCardModel for the profile layout.
 *
 * PURE. The rows are the Profile Card fields an app's feed already answers (full_name, avatar_image, status, rating_text, badge, tags, details,
 * price_line, button_label, button_url), so the same feed draws a Profile Card on a page and a profile card in the grid. Nothing here names an
 * app or a kind of person. Identity is the booking address, like a product card's is its route.
 */

import { createModel, ACTION_KIND } from '../model.js';

function lines(text) {
	return String(text || '').split('\n').map((l) => l.trim()).filter(Boolean);
}

function initials(name) {
	return String(name || '').split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0].toUpperCase()).join('');
}

export function adaptProfile(row) {
	const name = row.full_name || '';
	const href = row.card_url || row.button_url || '#';
	return createModel({
		id: href,
		href,
		itemCode: null,
		title: name,
		media: { src: row.avatar_image || null, alt: name, fallbackInitials: initials(name) },
		profile: {
			online: row.status || '',
			onlineTone: row.status_tone === 'busy' ? 'busy' : '',  // the feed says they are with someone: red, not green
			badge: row.badge || '',
			tags: lines(row.tags),
			lines: lines(row.details),
			rating: row.rating_text || '',
			ratingValue: Number(row.rating_value) || 0,
			reviews: row.reviews_text || '',
			footer: row.footer || '',
			price: row.price_line || '',
			priceWas: row.price_was || '',  // the fee a free or cheaper session replaces, struck out
			highlight: row.highlight || '',
			actionLabel: row.button_label || '',
			actionUrl: row.button_url || href,
			action2Label: row.button2_label || '',  // a second button, when the feed gives one
			action2Url: row.button2_url || '',
			buyPlace: row.buy_place === 'side' ? 'side' : '',  // the feed may ask for the price and the button beside the person; blank is along the bottom, as ever
		},
		actions: { kind: ACTION_KIND.READMORE },
	});
}

export function adaptProfiles(rows) {
	return (rows || []).map(adaptProfile);
}
